import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import getErrorMessage from '../../utils/getErrorMessage';

const initialState = {
    isLoading: true,
    logins: [],
    filters: {
        companyid: null,
        roleid: null,
    },
    error: '',
};

export const fetchAMLogins = createAsyncThunk(
    'amLogins/fetchAMLogins',
    async (params, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOST_API_KEY}/authentication`, {
                params,
            });

            return response.data;
        } catch (err) {
            const code = err?.errors ? err.errors[0]?.code : null;
            const message = getErrorMessage(code);
            return rejectWithValue(message);
        }
    }
);


const amLoginsSlice = createSlice({
    name: 'amLoginsSlice',
    initialState,
    reducers: {
        setFilters(state, action) {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetFilters(state) {
            state.filters = {
                ...state.filters,
                companyid: null,
                roleid: null,
            };
        },
    },
    extraReducers(builder) {
        builder.addCase(fetchAMLogins.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchAMLogins.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.error = '';
            state.logins = payload.data;
        });
        builder.addCase(fetchAMLogins.rejected, (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        });
    },
});

export const { setFilters, resetFilters } = amLoginsSlice.actions;

export default amLoginsSlice.reducer;

export const selectAMLoginsFilters = (state) => state.amLogins.filters;
export const selectAMLoginsData = (state) => state.amLogins.logins;
export const selectAMLoginsLoading = (state) => state.amLogins.isLoading;
export const selectAMLoginsError = (state) => state.amLogins.error;
